import React, { useEffect, useState } from "react";
import { Text, TextTitle } from "./Texts";
import { useDispatch, useSelector } from "react-redux";

import Column from "./Column";
import Dropdown from "./Dropdown";
import Icon from "./Icon";
import PropTypes from "prop-types";
import Row from "./Row";
import colors from "../styles/colors";
import mainActions from "modules/main/actions";
import mainSelectors from "modules/main/selectors";
import facebookSelectors from "modules/facebook/selectors";
import googleSelectors from "modules/google/selectors";
import styled from "styled-components";

const AccountSelector = ({ mobile }) => {
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const currentFacebookAd = useSelector((state) => mainSelectors.currentFacebookAd(state));
  const currentDashboard = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const facebookSettingsResult = useSelector((state) => facebookSelectors.getFacebookSettingsResult(state));
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));
  const [ads, setAds] = useState(authAdproResult ? authAdproResult.ads : []);
  const [accounts, setAccounts] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentDashboard.data.dashboard === "google") {
      if (
        authAdproResult.data.adwords_managed_service !== "N" &&
        authAdproResult.data.adwords_managed_service !== "U"
      ) {
        setAds(authAdproResult.data.ads);
      } else {
        if (businessInfoResult.data.adwords_id) {
          if (
            businessInfoResult.data.adwords_id &&
            (authAdproResult.data.adwords_managed_service === "N" ||
              authAdproResult.data.adwords_managed_service === "U")
          ) {
            setAds([
              {
                ads_account_id: businessInfoResult.data.adwords_id,
                account_name: businessInfoResult.data.adwords_name,
                rmp_business_id: businessInfoResult.data.business_id,
              },
            ]);
          } else if (authAdproResult.data.ads) {
            setAds(authAdproResult.data.ads);
          }
        }
      }
    } else if (currentDashboard.data.dashboard === "facebook" && facebookSettingsResult.data) {
      setAds(facebookSettingsResult.data);
    }
  }, [currentDashboard, authAdproResult, facebookSettingsResult, businessInfoResult]);

  useEffect(() => {
    if (ads && ads.length > 0) {
      let accountsTemp = [];
      ads.forEach((item, index) => {
        if (currentDashboard.data.dashboard === "google") {
          accountsTemp.push({
            check: item.ads_account_id,
            id: item.account_name || "No Name",
            isActive: true,
          });
        } else {
          accountsTemp.push({
            check: item.fb_ads_account_id,
            id: item.fb_ads_account_name || "No Name",
            isActive: true,
          });
        }
      });
      setAccounts(accountsTemp);
    }
  }, [ads]);

  const desktopView = ({ onClick }) => {
    let account;

    if (currentDashboard.data.dashboard === "google") {
      account = accounts.filter((item) => item.check === currentAd.ads_account_id)[0];
    } else if (currentDashboard.data.dashboard === "facebook") {
      account = accounts.filter((item) => item.check === currentFacebookAd.ads_account_id)[0];
    }

    if (accounts.length > 1) {
      return (
        <ContainerDesktop columnSpacing="4px" onClick={onClick}>
          <Column>
            <TextTitle className="title" size="14px">
              {account && account.id ? account.id : ""}
            </TextTitle>
            {/* <Text color={account.isActive ? colors.positive : colors.descriptionText} size="10px">
              <Icon name="icon-circle" size="8px" color={account.isActive ? colors.positive : colors.descriptionText}></Icon>
              Active
            </Text> */}
          </Column>
          <Column wrap>
            <Icon name="icon-down-dir" size="16px"></Icon>
          </Column>
        </ContainerDesktop>
      );
    } else {
      return (
        <ContainerDesktop className="-unselectable" columnSpacing="4px">
          <TextTitle className="title" size="14px">
            {account && account.id ? account.id : ""}
          </TextTitle>
        </ContainerDesktop>
      );
    }
  };

  const mobileView = ({ onClick }) => {
    let account;

    if (currentDashboard.data.dashboard === "google") {
      account = accounts.filter((item) => item.check === currentAd.ads_account_id)[0];
    } else if (currentDashboard.data.dashboard === "facebook") {
      account = accounts.filter((item) => item.check === currentFacebookAd.ads_account_id)[0];
    }

    if (accounts.length > 1) {
      return account && account.id ? (
        <ContainerMobile alignItems="left" onClick={onClick}>
          {/* <Column wrap>
            <div className={account.isActive ? "online-icon" : "offline-icon"}></div>
          </Column> */}
          <Column>
            <Text className="title" size="14px" color={colors.black}>
              {account.id}
            </Text>
          </Column>
          <Column wrap>
            <Icon name="icon-down-dir" size="16px" color={colors.black}></Icon>
          </Column>
        </ContainerMobile>
      ) : null;
    } else {
      return account && account.id ? (
        <ContainerMobile alignItems="left">
          <Text className="title" size="14px" color={colors.black}>
            {account.id}
          </Text>
        </ContainerMobile>
      ) : null;
    }
  };

  const dropdownItems = accounts.map((account) => ({
    check: account.check,
    title: account.id,
    value: account.id,
    account: account,
  }));

  const onDropdownSelected = (item) => {
    const select = ads.filter((ad) => item.check === ad.ads_account_id)[0];
    dispatch(mainActions.SetAd(select));
  };

  if (accounts.length > 0) {
    return (
      <Dropdown
        CustomDropdownButton={mobile ? mobileView : desktopView}
        items={dropdownItems}
        onSelected={onDropdownSelected}
        minWidth="300px"
        position={{ top: "40px" }}
      />
    );
  } else {
    return null;
  }
};

AccountSelector.propTypes = {
  mobile: PropTypes.bool,
};

export default AccountSelector;

const ContainerDesktop = styled(Row)`
  padding: 0 16px 16px;
  border-bottom: 1px solid #ececec;
  align-items: baseline;

  &.-unselectable {
    cursor: inherit;
  }

  & .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const ContainerMobile = styled(Row)`
  background-color: transparent;
  padding: 0 0 0px;
  border-radius: 6px;
  margin: 0px 0 0;
  font-weight: normal;
  justify-content: center;

  .title {
    text-align: center;
  }
`;
